import { render, staticRenderFns } from "./hidden-attributes-list.component.vue?vue&type=template&id=2ebb7938&scoped=true"
import script from "./hidden-attributes-list.component.vue?vue&type=script&lang=ts"
export * from "./hidden-attributes-list.component.vue?vue&type=script&lang=ts"
import style0 from "./hidden-attributes-list.component.vue?vue&type=style&index=0&id=2ebb7938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb7938",
  null
  
)

export default component.exports